// extracted by mini-css-extract-plugin
export var orderDetails = "_ro-2";
export var orderImage = "_ro-1";
export var orderMeta = "_ro-3";
export var orderSummary = "_ro-0";
export var rightArrow = "_ro-4";